// Static catalog of niche/luxury perfumes
// To modify products, edit this file directly.

export const WHATSAPP_NUMBER = "+393272507259";

export const products = [
  {
    id: "creed-aventus",
    name: "Aventus",
    brand: "Creed",
    formato: "100 ml",
    stato: { it: "Nuovo, sigillato", en: "New, sealed" },
    prezzo: 380,
    descrizione: {
      it: "Iconico legno fumé con ananas, mirto e muschio di quercia. Una firma di carattere, simbolo di successo e individualità.",
      en: "Iconic smoky wood with pineapple, birch and oakmoss. A signature of character, symbol of success and individuality.",
    },
    stagionalita: { it: "Tutto l'anno", en: "Year-round" },
    scia: { it: "Intensa", en: "Strong" },
    durata: { it: "8 — 10 ore", en: "8 — 10 hours" },
    image: "https://images.unsplash.com/photo-1694179023466-cb438ce7ae0b?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "tom-ford-tobacco-vanille",
    name: "Tobacco Vanille",
    brand: "Tom Ford",
    formato: "50 ml",
    stato: { it: "Nuovo, sigillato", en: "New, sealed" },
    prezzo: 290,
    descrizione: {
      it: "Tabacco speziato e vaniglia avvolgente. Una carezza orientale, calda e dichiaratamente sensuale.",
      en: "Spiced tobacco and enveloping vanilla. An oriental caress, warm and unapologetically sensual.",
    },
    stagionalita: { it: "Autunno · Inverno", en: "Autumn · Winter" },
    scia: { it: "Intensa", en: "Strong" },
    durata: { it: "10 — 12 ore", en: "10 — 12 hours" },
    image: "https://images.unsplash.com/photo-1652464945507-687e44a1017a?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "mfk-baccarat-rouge-540",
    name: "Baccarat Rouge 540",
    brand: "Maison Francis Kurkdjian",
    formato: "70 ml",
    stato: { it: "Nuovo, sigillato", en: "New, sealed" },
    prezzo: 340,
    descrizione: {
      it: "Ambra e zafferano cristallini, fusi con cedro e gelsomino. Un'aura luminosa, eterea, inconfondibile.",
      en: "Crystalline amber and saffron, fused with cedar and jasmine. A luminous, ethereal, unmistakable aura.",
    },
    stagionalita: { it: "Tutto l'anno", en: "Year-round" },
    scia: { it: "Intensa", en: "Strong" },
    durata: { it: "10+ ore", en: "10+ hours" },
    image: "https://images.unsplash.com/photo-1612871178341-33f941a841e3?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "xerjoff-naxos",
    name: "Naxos",
    brand: "Xerjoff",
    formato: "100 ml",
    stato: { it: "Nuovo, sigillato", en: "New, sealed" },
    prezzo: 280,
    descrizione: {
      it: "Tabacco al miele, lavanda e fava tonka. Una composizione mediterranea, voluttuosa e rilassata.",
      en: "Honeyed tobacco, lavender and tonka bean. A Mediterranean composition, voluptuous and relaxed.",
    },
    stagionalita: { it: "Autunno · Inverno", en: "Autumn · Winter" },
    scia: { it: "Moderata", en: "Moderate" },
    durata: { it: "8 — 10 ore", en: "8 — 10 hours" },
    image: "https://images.pexels.com/photos/32630382/pexels-photo-32630382.jpeg?auto=compress&cs=tinysrgb&w=900&q=80",
  },
  {
    id: "parfums-de-marly-layton",
    name: "Layton",
    brand: "Parfums de Marly",
    formato: "75 ml",
    stato: { it: "Nuovo, sigillato", en: "New, sealed" },
    prezzo: 260,
    descrizione: {
      it: "Mela, lavanda e vaniglia su un cuore di gelsomino. Un'eleganza moderna, dolce e maschile insieme.",
      en: "Apple, lavender and vanilla over a jasmine heart. A modern elegance, sweet and masculine at once.",
    },
    stagionalita: { it: "Primavera · Autunno", en: "Spring · Autumn" },
    scia: { it: "Moderata", en: "Moderate" },
    durata: { it: "8 — 10 ore", en: "8 — 10 hours" },
    image: "https://images.unsplash.com/photo-1592945403244-b3fbafd7f539?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "amouage-interlude-man",
    name: "Interlude Man",
    brand: "Amouage",
    formato: "100 ml",
    stato: { it: "Usato — 90%", en: "Used — 90% full" },
    prezzo: 210,
    descrizione: {
      it: "Incenso, ambra grigia e cuoio. Una scultura olfattiva orientale, densa e profondamente meditativa.",
      en: "Frankincense, ambergris and leather. An oriental olfactory sculpture, dense and deeply meditative.",
    },
    stagionalita: { it: "Autunno · Inverno", en: "Autumn · Winter" },
    scia: { it: "Intensa", en: "Strong" },
    durata: { it: "12+ ore", en: "12+ hours" },
    image: "https://images.unsplash.com/photo-1541643600914-78b084683601?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "byredo-gypsy-water",
    name: "Gypsy Water",
    brand: "Byredo",
    formato: "100 ml",
    stato: { it: "Nuovo, sigillato", en: "New, sealed" },
    prezzo: 220,
    descrizione: {
      it: "Bergamotto, pino, incenso e vaniglia. Un viaggio scandinavo tra natura e libertà nomade.",
      en: "Bergamot, pine, frankincense and vanilla. A Scandinavian journey between nature and nomadic freedom.",
    },
    stagionalita: { it: "Primavera · Estate", en: "Spring · Summer" },
    scia: { it: "Leggera", en: "Soft" },
    durata: { it: "6 — 8 ore", en: "6 — 8 hours" },
    image: "https://images.unsplash.com/photo-1547887537-6158d64c35b3?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "initio-oud-for-greatness",
    name: "Oud for Greatness",
    brand: "Initio",
    formato: "90 ml",
    stato: { it: "Nuovo, sigillato", en: "New, sealed" },
    prezzo: 360,
    descrizione: {
      it: "Oud nepalese, lavanda e zafferano. Una presenza regale e magnetica, da cerimonia interiore.",
      en: "Nepalese oud, lavender and saffron. A regal, magnetic presence — almost ceremonial.",
    },
    stagionalita: { it: "Autunno · Inverno", en: "Autumn · Winter" },
    scia: { it: "Intensa", en: "Strong" },
    durata: { it: "10+ ore", en: "10+ hours" },
    image: "https://images.pexels.com/photos/8217775/pexels-photo-8217775.jpeg?auto=compress&cs=tinysrgb&w=900&q=80",
  },
  {
    id: "roja-elysium",
    name: "Elysium Parfum Cologne",
    brand: "Roja Parfums",
    formato: "100 ml",
    stato: { it: "Nuovo, sigillato", en: "New, sealed" },
    prezzo: 420,
    descrizione: {
      it: "Pompelmo, cedro e muschio bianco. Una freschezza solare, raffinata, di rara luminosità.",
      en: "Grapefruit, cedar and white musk. A solar freshness, refined, of rare luminosity.",
    },
    stagionalita: { it: "Primavera · Estate", en: "Spring · Summer" },
    scia: { it: "Moderata", en: "Moderate" },
    durata: { it: "7 — 9 ore", en: "7 — 9 hours" },
    image: "https://images.unsplash.com/photo-1615634260167-c8cdede054de?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "le-labo-santal-33",
    name: "Santal 33",
    brand: "Le Labo",
    formato: "50 ml",
    stato: { it: "Nuovo, sigillato", en: "New, sealed" },
    prezzo: 240,
    descrizione: {
      it: "Sandalo, papiro, cardamomo e cuoio. Una firma urbana, contemporanea, irripetibile.",
      en: "Sandalwood, papyrus, cardamom and leather. An urban, contemporary, irreplaceable signature.",
    },
    stagionalita: { it: "Tutto l'anno", en: "Year-round" },
    scia: { it: "Moderata", en: "Moderate" },
    durata: { it: "8 — 10 ore", en: "8 — 10 hours" },
    image: "https://images.unsplash.com/photo-1588405748880-12d1d2a59d75?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "nasomatto-black-afgano",
    name: "Black Afgano",
    brand: "Nasomatto",
    formato: "30 ml",
    stato: { it: "Nuovo, sigillato", en: "New, sealed" },
    prezzo: 195,
    descrizione: {
      it: "Hashish, oud e cannabis verde. Una composizione oscura, ribelle, dichiaratamente notturna.",
      en: "Hashish, oud and green cannabis. A dark, rebellious, declaredly nocturnal composition.",
    },
    stagionalita: { it: "Autunno · Inverno", en: "Autumn · Winter" },
    scia: { it: "Intensa", en: "Strong" },
    durata: { it: "10+ ore", en: "10+ hours" },
    image: "https://images.unsplash.com/photo-1563170351-be82bc888aa4?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "ormonde-jayne-tolu",
    name: "Tolu",
    brand: "Ormonde Jayne",
    formato: "120 ml",
    stato: { it: "Nuovo, sigillato", en: "New, sealed" },
    prezzo: 250,
    descrizione: {
      it: "Balsamo di Tolù, frangipane e ambra. Una poesia balsamica, dorata, dal cuore antico.",
      en: "Tolu balsam, frangipani and amber. A balsamic, golden poem with an ancient heart.",
    },
    stagionalita: { it: "Autunno · Inverno", en: "Autumn · Winter" },
    scia: { it: "Moderata", en: "Moderate" },
    durata: { it: "8 — 10 ore", en: "8 — 10 hours" },
    image: "https://images.pexels.com/photos/965990/pexels-photo-965990.jpeg?auto=compress&cs=tinysrgb&w=900&q=80",
  },
];

export const getProductById = (id) => products.find((p) => p.id === id);

export const getBrands = () => Array.from(new Set(products.map((p) => p.brand))).sort();
